const Builder = require('../BuilderBase');

module.exports = class FixedText extends Builder {
    constructor(title, properties) {
        super('dataView_FixedText', title, properties);
    }
};
